import { Engine } from 'engine/Engine';
import { Entity } from 'engine/Entity';
import { EngineContext } from 'engine/components/EngineProvider';
import { Facet } from 'engine/facets/Facet';
import { UIFacet } from 'engine/facets/UIFacet';
import { V2 } from 'engine/lib/V2';
import { create } from 'engine/lib/create';
import { colors } from 'game/styles/theme';
import clamp from 'lodash/clamp';
import noop from 'lodash/noop';
import { createElement, useContext } from 'react';

interface Step {
  duration: number,
  start: () => void,
  update: (progress: number) => void,
}

let opacity = 0;
const overlay = create(UIFacet, {
  Component: () => {
    const engine = useContext(EngineContext);
    const [width, height] = engine.viewport;
    return createElement('div', {
      style: { width, height, background: colors.black, opacity },
    });
  },
});

export class Teleporter extends Facet {

  stepStart: number | null = null;
  steps: Step[] = [];

  teleport(entity: Entity, target: V2, engine: Engine) {
    this.steps = [{
      duration: 200,
      start: () => {
        engine.time.timeScale = 0;
        this.entity.addFacet(overlay, engine);
      },
      update: progress => { opacity = progress; },
    }, {
      duration: 100,
      start: () => {
        entity.transform.position[0] = target[0];
        entity.transform.position[1] = target[1];
      },
      update: noop,
    }, {
      duration: 200,
      start: noop,
      update: progress => { opacity = 1 - progress; },
    }, {
      duration: 0,
      start: () => {
        this.entity.removeFacet(overlay);
        engine.time.timeScale = 1;
      },
      update: noop,
    }];
  }

  update(delta: number, engine: Engine) {
    const step = this.steps[0];
    if (!step) return;
    if (!this.stepStart) {
      this.stepStart = engine.time.nowUnscaled;
      step.start();
    }
    const deltaUnscaled = engine.time.nowUnscaled - this.stepStart;
    const progress = clamp(deltaUnscaled / step.duration, 1);
    step.update(progress);
    if (progress === 1) {
      this.steps.shift();
      this.stepStart = null;
    }
  }
}
